import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
} from "@mui/material";

const eventNames = [
  "Wedding Reception: Romeo and Juliet",
  "Tech Expo 2024",
  "Concert Night Live",
  "Founders & Funders Gala",
  "Digital Nomad Meetup",
  "Festival of Lights",
  "Cultural Heritage Day",
  "AI in Business Forum",
  "Startup Grind Fest",
  "Wedding Bells: Emily & James",
  "Corporate Summit 2024",
  "Blockchain Future Fair",
  "Ceremony of Love",
  "Love in Bloom Wedding",
  "International Music Wave",
];

const imageUrls = [
  "https://static.wikia.nocookie.net/shrek/images/8/8b/Shrek_fiona_carriage.jpg",
  "https://images.unsplash.com/photo-1521305916504-4a1121188589",
  "https://images.unsplash.com/photo-1503428593586-e225b39bddfe",
  "https://images.unsplash.com/photo-1531058020387-3be344556be6",
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30",
];

const cities = [
  "Maputo", "Nairobi", "Cape Town", "New York", "Lisbon",
  "Paris", "Tokyo", "Dubai", "London", "São Paulo",
];

function getRandomItem(list) {
  return list[Math.floor(Math.random() * list.length)];
}

const GenerateEventsJson = () => {
  const [eventCount, setEventCount] = useState(1);

  const generateJsonFile = () => {
    const events = [];

    for (let i = 0; i < eventCount; i++) {
      const code = Math.random().toString(36).substring(2, 8).toUpperCase();
      const name = getRandomItem(eventNames);
      const city = getRandomItem(cities);
      const imageUrl = getRandomItem(imageUrls);

      events.push({
        eventCity: city,
        eventCoOwnerEmail: "",
        eventCoOwnerName: "Hido",
        eventCode: code,
        eventDescription:
          "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
        eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
        eventImageURL: imageUrl,
        eventLatitude: "-25.969248",
        eventLocation: "Parque Municipal das Flores",
        eventLongitude: "32.5731746",
        eventName: name,
        eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
        eventOwnerName: "Agnelio Hlavanguane",
        eventPrice: "$50",
        eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
        eventStatus: "Ongoing",
        eventVisibility: "Private",
        featured: true,
      });
    }

    const blob = new Blob([JSON.stringify(events, null, 2)], {
      type: "application/json",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `bulk_events_${eventCount}.json`;
    link.click();
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 500, mx: "auto", mt: 5 }}>
      <Typography variant="h6" gutterBottom>
        Generate Random Event JSON File
      </Typography>
      <TextField
        type="number"
        label="Number of Events"
        fullWidth
        value={eventCount}
        onChange={(e) => setEventCount(parseInt(e.target.value) || 1)}
        inputProps={{ min: 1 }}
        sx={{ mb: 3 }}
      />
      <Button variant="contained" onClick={generateJsonFile} fullWidth>
        Download JSON File
      </Button>
    </Paper>
  );
};

export default GenerateEventsJson;
